import { StatusBadge } from "@/components/common/ui-kit";
import { ITV_STATUS, SLA_STATE } from "@/lib/interventions";
import { PRIORITIES } from "@/components/activities/ActivityDialog";
import { fmtDateTime } from "@/lib/format";

export const ItvStatus = ({ status, testId }) => {
  const [label, tone] = ITV_STATUS[status] || [status, "neutral"];
  return <StatusBadge tone={tone} data-testid={testId}>{label}</StatusBadge>;
};

export const ItvPriority = ({ priority }) => {
  const p = PRIORITIES.find((x) => x.key === priority) || PRIORITIES[1];
  return <StatusBadge tone={p.tone} dot={false}>{p.label}</StatusBadge>;
};

export const SlaBadge = ({ itv, testId }) => {
  const state = itv.sla_state || "none";
  if (state === "none") return null;
  const [label, tone] = SLA_STATE[state];
  const due = itv.sla?.responded_at ? itv.sla?.resolution_due_at : itv.sla?.response_due_at;
  const paused = !!itv.sla?.paused_since;
  return (
    <StatusBadge tone={tone} title={due ? `Scadenza: ${fmtDateTime(due)}` : undefined} data-testid={testId}>
      {label}{paused ? " · in pausa" : ""}
    </StatusBadge>
  );
};
